// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"72":"36759fe3","581":"ebb6a87a","716":"ba26ca55"}[chunkId] + ".css";
};